// extracted by mini-css-extract-plugin
module.exports = {"small":"only screen and (min-width: 576px)","image":"Fc-WY","smallScreenImage":"_2y_Wm","icon":"_3bYkp"};